<template>
    <div id="redirect" class="d-flex align-items-center h-100 w-100 m-0 p-5 text-center">
        <div class="w-100 h-100 d-flex align-items-center">
            <lottie :options="defaultOptions" :height="400" :width="400" />
        </div>
    </div>
</template>


<script>
    import * as animationData from '../assets/LoginSuccess.json';    
    import { mapMutations } from 'vuex';

    export default {
        name: 'redirect',
        props: {
            redirectUri: { type: String, default: ''}
        },
        mounted() {            
            if (!this.redirectUri || this.redirectUri === '') {
                console.log('redirect: redirect uri was not provided! sending to home');
                this.$router.push({ name: 'home' });
            }
            else {
                console.log('redirect: mounted. redirecting to ' + this.redirectUri);
                var internalRedirect = this.redirectUri;
                var count = 3;
                var self = this;
                setInterval(function () {
                    count--;
                    if (count == 0) {
                        self.toggleFooter();
                        window.location.href = internalRedirect;
                        
                    }
                }, 1000);
            }
        },
        data() {
            return {
                defaultOptions: {
                    animationData: animationData.default,
                    animationSpeed: 1,
                    loop: false,
                },
            }
        },
        methods: {
            ...mapMutations(['toggleFooter'])
        }
    }
</script>

<style>
    #redirect {
    height: 100vh!important;

    }
    
</style>